<template>
    <div :class="['form-message', { 'shown' : shown }]" >
        <div class="form-message-inner" @click="close">
            <div class="form-message-inner-text" v-html="message"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormMessage',
        props: {
            message: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                shown: false
            }
        },
        mounted() {
            this.shown = true
        },
        methods: {
            close() {
                setTimeout(() => {
                    this.shown = false
                }, 100)
                setTimeout(() => {
                    this.$emit('hideMessage')
                }, 1000)
            }
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/_variables/color';

    .form-message {
        position: fixed;
        top: 58px;
        right: 0;
        max-width: 807px;
        width: 100%;
        opacity: 0;
        transition: opacity .8s;
        z-index: 10;

        &-inner {
            background: $color-error-light;
            max-width: 300px;
            padding: 17px;
            border-radius: 4px;
            margin: auto;
            display: block;
            text-align: center;
            cursor: pointer;

            &-text {
                color: white;
                font-size: 1.6rem;
            }
        }

        &.shown {
            opacity: 1;
        }
    }
</style>
